export const API_CONFIG = {
  BASE_URL: 'https://api.faseyhapos.mv/api',
  ADMIN_URL: 'http://localhost:8002/api', //'https://ad.faseyhapos.mv/api',
  STORAGE_URL: 'https://api.faseyhapos.mv/storage/',
} as const

export const getImageUrl = (path: string): string => {
  if (!path) return ''
  return `${API_CONFIG.STORAGE_URL}/${path.replace(/^\//, '')}`
}